import { ArrowRight, Calculator, Flame, ShieldCheck, Snowflake } from "lucide-react";
import { Button } from "../ui/button";
import { MEDIA } from "../../data/products";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative bg-zinc-950 overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={MEDIA.hero}
          alt="Montaż wełny mineralnej w ścianie szkieletowej"
          className="w-full h-full object-cover"
        />
        {/* Dark gradient overlay — strong on left for text contrast, fades to transparent right */}
        <div className="absolute inset-0 bg-gradient-to-r from-zinc-950 from-10% via-zinc-950/85 via-50% to-zinc-950/20 to-100%" />
        {/* Subtle bottom gradient for stripe */}
        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-zinc-950/80 to-transparent" />
      </div>

      {/* Diagonal red accent */}
      <div className="absolute -right-32 top-0 h-full w-96 bg-red-600 opacity-90 hidden lg:block transform skew-x-12 origin-top-right" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-[2px] w-12 bg-red-600" />
            <span className="font-tech text-xs sm:text-sm tracking-[0.3em] uppercase text-red-500 font-bold">
              BUDOBET.PL · Hurt + detal · cała Polska
            </span>
          </div>

          <h1 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] uppercase mb-5">
            Wełna mineralna<br />
            <span className="text-red-500">w najlepszych cenach<br />w Polsce.</span>
          </h1>

          <p className="text-zinc-300 text-base sm:text-lg max-w-2xl mb-6 leading-relaxed">
            Sprzedaż <strong className="text-white">hurtowa i detaliczna</strong> wełny szklanej
            0,033 · 0,035 · 0,039 W/m·K. Klasa A1, hydrofobizowana, certyfikowana.
            <span className="block mt-2 text-red-400 font-semibold">
              ✓ Darmowa dostawa od 4 palet · cała Polska
            </span>
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <Button
              asChild
              className="rounded-none bg-red-600 hover:bg-red-700 text-white font-bold uppercase tracking-wider px-8 h-14 text-base group"
              data-testid="hero-cta-products"
            >
              <a href="#kontakt">
                Zamów wycenę
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition" />
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              className="rounded-none bg-transparent border-2 border-white text-white hover:bg-white hover:text-black font-bold uppercase tracking-wider px-8 h-14 text-base"
              data-testid="hero-cta-calculator"
            >
              <a href="#kalkulator">
                <Calculator className="mr-2 h-5 w-5" />
                Policz zapotrzebowanie
              </a>
            </Button>
          </div>

          {/* Trust badges */}
          <div className="grid grid-cols-3 gap-4 sm:gap-8 border-t border-zinc-700 pt-6">
            {[
              { icon: Flame, label: "Klasa A1", sub: "Niepalna" },
              { icon: ShieldCheck, label: "Hurt + detal", sub: "Cała Polska" },
              { icon: Snowflake, label: "Od 4 palet", sub: "Darmowa dostawa" },
            ].map((b) => (
              <div key={b.label} className="flex items-start gap-3">
                <b.icon className="h-7 w-7 text-red-500 shrink-0" strokeWidth={1.8} />
                <div>
                  <div className="font-display text-white text-lg leading-none">
                    {b.label}
                  </div>
                  <div className="font-tech text-xs uppercase tracking-widest text-zinc-400 mt-1">
                    {b.sub}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom diagonal strip */}
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-stripes" />
    </section>
  );
}
